import { render } from "./TaxiReservationChat.vue?vue&type=template&id=40411d42&scoped=true"
import script from "./TaxiReservationChat.vue?vue&type=script&lang=js"
export * from "./TaxiReservationChat.vue?vue&type=script&lang=js"

import "./TaxiReservationChat.vue?vue&type=style&index=0&id=40411d42&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40411d42"]])

export default __exports__